import reducer from './reducer'

import * as noticesOperations from './operations'
import * as noticesSelectors from './selectors'

export { noticesOperations, noticesSelectors }

export default reducer
